// @/services/LessonsClient.js
import { CandyClient } from "@cabysis/candy-client";
import { getToken } from "@/utilities/storage";
import { BACK_END_URL } from "@/utilities/config";

const lessonsOptions = {
  baseUrl: `${BACK_END_URL}/lesson`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
  getToken: () => getToken(),
};

export class LessonsClient extends CandyClient {
  constructor() {
    super(lessonsOptions);
  }

  // Get single lesson by ID
  async getLessonById(id) {
    return this.get(`/id/${id}`);
  }

  // Get all lessons for a chapter
  async getAllLessonsByChapter(chapterId) {
    return this.get(`/list/${chapterId}`);
  }

  // Create a new lesson (requires auth)
  async createLesson(dto) {
    return this.post(`/create`, dto, {
      customHeaders: { 
        Authorization: `Bearer ${getToken()}`,
        'Content-Type': 'application/json'
      }
    });
  }

  // Update a lesson (requires auth)
  async updateLesson(id, dto) {
    return this.put(`/update/${id}`, dto, {
      customHeaders: { 
        Authorization: `Bearer ${getToken()}`,
        'Content-Type': 'application/json'
      }
    });
  }

  // Delete a lesson (requires auth)
  async deleteLesson(id) {
    return this.delete(`/delete/${id}`, null, {
      customHeaders: { Authorization: `Bearer ${getToken()}` },
    });
  }  
}